import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { terapkanPenandaDariLokasi } from './lib/terakhir-dilihat';
import { segarkanServiceWorker } from './lib/webPush';
import './styles.css';

/*
 * Ketukan notifikasi HP (#1756) — sw.js membuka aplikasi dengan `?dibaca=…`. Diterapkan SEBELUM
 * render: bel dan kartu "Perlu perhatian" membaca penanda ini sekali saat mount, jadi menerapkannya
 * sesudahnya berarti angka lama sempat tampil (atau bertahan) di layar pertama. Parameternya lalu
 * dibuang dari URL supaya memuat ulang atau membagikan tautan tidak menerapkannya lagi.
 */
terapkanPenandaDariLokasi(window.location, (alamat) =>
  window.history.replaceState(window.history.state, '', alamat),
);

const root = document.getElementById('root');
if (!root) {
  throw new Error('Elemen #root tidak ditemukan.');
}
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Dipanggil sekali per boot, bukan hanya saat mengaktifkan push — supaya perbaikan di `sw.js`
// sampai ke peramban yang sudah pernah membuka aplikasi ini tanpa menunggu siklus update alami.
void segarkanServiceWorker();
